import React from "react";
import { Navbar, Container, Nav, NavDropdown, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Logo from "../../../assets/img/virtual-psych-logo.png";
import "./header.scss";

const Header = () => {
    return (
        <Navbar bg="white" expand="lg" className="main-header navbar">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center logo">
                    <img src={Logo} alt="logo" />
                </Navbar.Brand>
                <div className="header-phone header-phone--mobile">
                    <a href="tel:+18778394824" className="header-phone-link">Call (877) 839-4824</a>
                </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Item>
                            <Nav.Link as={Link} to="/" className="home">HOME</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Link} to="/overview" className="overview">OVERVIEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <NavDropdown title="MEMBERS" id="basic-nav-dropdown" className="member">
                                <NavDropdown.Item as={Link} to="/how-virtulpsych-works">How does it work?</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/what-can-i-use-it-for">What can i use it for?</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/who-are-the-doctors">Who are the doctors?</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/pricing">Rate without Insurance</NavDropdown.Item>
                            </NavDropdown>
                        </Nav.Item>
                    </Nav>
                    <div className="header-phone header-phone--desktop">
                        <a href="tel:+18778394824" className="header-phone-link">Call (877) 839-4824</a>
                    </div>
                    <div className="client-login">
                        <Button
                            variant="memeber-btn"
                            style={{ color: "#fff", fontWeight: 400 }}
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href='https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1';
                            }}
                        >Book Online</Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
